(function($, Drupal) {
  'use strict';
  Drupal.behaviors.back_to_top = {
    attach: function(context, settings) {
      let $back_to_top_items = $('.back-to-top', context);
      const $jump_to_link_ul = $('#jump-link-list', context);
      $back_to_top_items.once('back-to-top').each(function() {
        let $item_text = $(this).text();
        // remove spaces front string
        let $item_id = $item_text.toLowerCase().replace(/ /g, '-');
        $(this).attr('id', $item_id);

        $jump_to_link_ul.append('<li><a href="#' + $item_id + '">' + $item_text + '</a></li>');
        // inject backtop top links
        $(this).append('<a href="#content-top" class="back-to-top-link">Back to top</a>');
      });

      let $jump_to_link = $('#jump-link-list a', context);

      if ($back_to_top_items.length > 0) {
        $('.jump-links').fadeIn(500);

        $jump_to_link.on('click', function(e) {
          e.preventDefault();
          let $this = $(this);
          let $target = $($this.attr('href'));
          let $target_offset = $target.offset().top;
          $('html, body').animate({ scrollTop: $target_offset }, 500);
        });

        $back_to_top_items.on('click', function(e) {
          e.preventDefault();
          $('html, body').animate({ scrollTop: 0 }, 500);
        });
      }
    }
  };
})(jQuery, Drupal);
